import { NumberInput } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventAbsencePenaltyPointsInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { absencePenaltyPoints } = values;
    const hasError = absencePenaltyPoints !== null
        && absencePenaltyPoints !== undefined
        && absencePenaltyPoints >= 0;

    const updateValue = (value: number | string) => {
        updateValues({
            ...values,
            absencePenaltyPoints: value === '' ? null : Number(value),
        });
    };

    return (
        <NumberInput
            id="event-absence-penalty-points-input"
            label={intl.formatMessage(messages.label)}
            placeholder={intl.formatMessage(messages.placeholder)}
            max={-1}
            onChange={updateValue}
            value={absencePenaltyPoints ?? undefined}
            error={hasError ? intl.formatMessage(messages.error) : undefined}
            radius="md"
            size="md"
        />
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventAbsencePenaltyPointsInput.label',
        defaultMessage: 'Punkty ujemne za nieobecność',
    },
    placeholder: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventAbsencePenaltyPointsInput.placeholder',
        defaultMessage: 'Np. -5',
    },
    error: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventAbsencePenaltyPointsInput.error',
        defaultMessage: 'Kara musi być liczbą ujemną.',
    },
});

export default EventAbsencePenaltyPointsInput;
